<script>
    import { metaInfo } from "@/core/MetaInfo";
    import TheDetailWrapper from "@auto-admin/components/TheDetailWrapper";

    export default {
        name: "TestDrivePointDetail",
        props: {
            statusPage: String,
        },
        components: { TheDetailWrapper },
        data() {
            return {
                form: {
                    contact: {
                        email: "",
                        name: "",
                        phone: "",
                    },
                    createdAt: "",
                    modelId: "",
                    pointId: "",
                    status: "",
                    time: "",
                },
                nameModel: "",
            };
        },
        computed: {
            isNew() {
                return this.statusPage === "new";
            },
            isView() {
                return this.statusPage === "view";
            },
            isEdit() {
                return this.statusPage === "edit";
            },
            title() {
                let filtered = {
                    new: "Добавить тестдрайв",
                    view: "Тестдрайв",
                    edit: "Редактировать тестдрайв",
                };
                return filtered[this.statusPage];
            },
        },
        mounted() {
            if (this.isEdit || this.isView) {
                this.loadDataForEdited();
            }
        },
        methods: {
            send() {
                if (this.isNew) {
                    // this.handlerForCreate();
                }
                if (this.isEdit) {
                    this.handlerForEdit();
                }
                if (this.isView) {
                    this.handlerForView();
                }
            },
            handlerForView() {
                this.$router.push({
                    name: "TestDriveOrderEdit",
                    params: {
                        slug: this.$route.params.slug,
                    },
                });
            },
            handlerForEdit() {
                this.form.contact.phone = this.form.contact.phone.replace("+7", "");
                this.$store.autoAdminApi
                    .editTestDriveOrder(this.$route.params.slug, this.form)
                    .then(() => {
                        this.$router.push({
                            name: "TestDriveOrders",
                        });
                    });
            },
            // handlerForCreate() {
            //     this.$store.autoAdminApi.createTestDrivePoint(this.form).then(({ data }) => {
            //         this.$router.push({
            //             name: "TestDrivePointView",
            //             params: {
            //                 slug: data.id,
            //             },
            //         });
            //     });
            // },
            loadDataForEdited() {
                this.$store.autoAdminApi
                    .getTestDriveOrder(this.$route.params.slug)
                    .then(({ data }) => {
                        this.form = data;
                        this.form.contact.phone = "+7" + data.contact.phone;
                        this.$store.autoAdminApi.getModel(data.modelId).then((res) => {
                            this.nameModel = res.data.name;
                        });
                    });
            },
            getStatus(value) {
                let filtered = {
                    closed: "Закрыта",
                    in_progress: "В процесс",
                    new: "Новая",
                };
                return filtered[value];
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <div class="vendor-detail">
        <the-detail-wrapper
            :title="title"
            type-list="/testdrive-orders"
            :current-status="statusPage"
            @handler-submit="send"
        >
            <b-field label="Статус">
                <b-select placeholder="Выбрать статус" v-model="form.status">
                    <option value="new">Новый</option>
                    <option value="in_progress">В процессе</option>
                    <option value="closed">Закрыт</option>
                </b-select>
            </b-field>
            <b-field label="Модель">
                <b-input v-model="nameModel" disabled=""></b-input>
            </b-field>
            <b-field label="Имя">
                <b-input v-model="form.contact.name"></b-input>
            </b-field>
            <b-field label="Почта">
                <b-input v-model="form.contact.email"></b-input>
            </b-field>
            <b-field label="Телефон">
                <b-input v-model.number="form.contact.phone"></b-input>
            </b-field>

            <b-field label="Дата создания">
                <b-input v-model.number="form.createdAt"></b-input>
            </b-field>
            <b-field label="Id model">
                <b-input v-model.number="form.modelId" disabled=""></b-input>
            </b-field>
            <b-field label="Id точки">
                <b-input v-model.number="form.pointId"></b-input>
            </b-field>
            <b-field label="Время">
                <b-input v-model.number="form.time"></b-input>
            </b-field>
        </the-detail-wrapper>
    </div>
</template>

<style lang="scss"></style>
